/** Money is kept in minor units (pesewas). */
let SYMBOL = "₵";
export const setCurrencySymbol = (s: string) => {
  SYMBOL = s || "₵";
};
export const money = (minor: number | null | undefined, opts: { sign?: boolean } = {}) => {
  const n = (minor ?? 0) / 100;
  const s = `${SYMBOL}${Math.abs(n).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  return n < 0 ? `− ${s}` : opts.sign && n > 0 ? `+ ${s}` : s;
};
export const moneyShort = (minor: number | null | undefined) => `${SYMBOL}${Math.round((minor ?? 0) / 100).toLocaleString("en-GB")}`;
/** "12.50" / "12" → 1250. */
export const toMinor = (v: string | number) => Math.round((Number(String(v).replace(/[^\d.]/g, "")) || 0) * 100);
export const fromMinor = (minor: number) => (minor / 100).toFixed(2);

export const time = (t: number) => new Date(t).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
export const date = (t: number) => new Date(t).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
export const dateTime = (t: number) => new Date(t).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
export const ago = (t: number | null | undefined) => {
  if (!t) return "never";
  const m = Math.round((Date.now() - t) / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} h ago`;
  return date(t);
};
export const addMonths = (t: number, m: number) => {
  const d = new Date(t);
  d.setMonth(d.getMonth() + m);
  return d.getTime();
};
export const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join("");
/** Group a 15-digit IMEI as 2-6-6-1 for reading out; anything else is shown as is. */
export const fmtSerial = (s: string) => (/^\d{15}$/.test(s) ? `${s.slice(0, 2)} ${s.slice(2, 8)} ${s.slice(8, 14)} ${s.slice(14)}` : s);
export const uuid = () => {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6]! & 0x0f) | 0x40;
  b[8] = (b[8]! & 0x3f) | 0x80;
  const h = [...b].map((x) => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
};
